import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

// material-ui
import Link from "@mui/material/Link";

// project imports
import { DASHBOARD_PATH } from "config";
import Logo from "ui-component/Logo";

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ compact = false }) {
  return (
    <Link
      component={RouterLink}
      to={DASHBOARD_PATH}
      aria-label="theme-logo"
      sx={{
        textDecoration: "none !important",
        "&:hover": { textDecoration: "none !important" },
        "&:focus": { textDecoration: "none !important" },
        "&:visited": { textDecoration: "none !important" },
      }}
    >
      <Logo compact={compact} />
    </Link>
  );
}

LogoSection.propTypes = {
  compact: PropTypes.bool,
};
